<script setup lang="ts">
import GreenTickIcon from '@/components/icons/GreenTickIcon.vue';

interface BenefitProps {
  title: string;
  text: string;
}

// eslint-disable-next-line no-undef, @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<BenefitProps>(), {
  title: 'Benefício Exemplo',
  text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type.",
});
</script>

<template>
  <div class="md:w-[28rem] bg-[#E8E8E8] p-6  md:h-64">
    <div class="flex items-center gap-4 mb-4">
      <div class="w-8 h-8 bg-adv-green-100 rounded-full">
        <GreenTickIcon class="w-8 h-8 text-adv-green-500" />
      </div>
    
    <h3 class="font-bold text-adv-blue-800 text-2xl tracking-wider">{{ title }}</h3>
    </div>
   
    <p class="text-adv-gray-500">{{ text }}</p>
    
  </div>
</template>
